// Port of api/fuel/app/classes/filter/search/users/sorts/query/ratings.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'ratings',
	post: false,
	require: function(config, filter) { return sorted('ratings', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('u.user_count_ratings', sortReverse('ratings', filter), sortPriority('ratings', filter))
	}
}
